import { ref, computed } from '@vue/composition-api'
import { CampaignsService, UpdatesService } from '../services';
import moment from 'moment';
import { postUpdates } from '../../firebase'
import useStore from './useStore'
import useRouter from './useRouter'
import useUserId from './useUserId'

const useCpInfo = (updateInfo) => {

    const cpCampaignsInfo = ref([])
    const loading = ref(false)
    const campaignData = ref(null)
    const formattedDate = ref(null)
    const {state, store} = useStore()
    const {router} = useRouter()
    const { userId } = useUserId();


    const inPremium = computed(() => store.getters.inPremium)

    const canPostUpdate = async () => {
        if(inPremium.value) {
            return true
        }
        const postedUpdates = await UpdatesService.getUpdates({
            start: 0, 
            size: 1000, 
            must: [{
                "bool": {
                    "must": [{
                        "term": {
                            "uid": userId
                        }
                    },
                    {
                        "exists": {
                            "field": "kickstarterDraftUrl"
                        }
                    }]
                }
            }],
        })

        const postedUpdatesCount = postedUpdates.data.hits.length

        if(postedUpdatesCount > 0) {
            return false
        }

        return true

    }

    const getProperPromoImage = (campaignInfo) => {
        return ((campaignInfo.promo_image === campaignInfo.image || !campaignInfo.promo_image) && campaignInfo.thumbnails && campaignInfo.thumbnails.original) ? 
                    campaignInfo.thumbnails.original :
                    campaignInfo.promo_image
    }

    const getPromoInfo = async () => {

        const {cid} = updateInfo

        const spotsPositions = updateInfo.spots
                            .map((spot, index) => {
                                if(spot && spot.cpid) {
                                    return {
                                        id: spot.cpid,
                                        index: String(index)
                                    }
                                }
                                return spot
                            })
                            .filter(item => item)
                            .reduce((obj, item) => {
                                    obj[item.id] = item.index
                                    return obj
                            }, {})


        const campaignsIds =  updateInfo
                                .spots
                                .filter(spot => spot && spot.cpid)
                                .map(spot => spot.cpid)
        
        const dateData = updateInfo.date.seconds ? new Date(updateInfo.date.seconds * 1000) : updateInfo.date
        formattedDate.value = moment(dateData).format('DD/MM/YYYY')

        loading.value = true

        const campaignDoc = await CampaignsService.getCampaignById(cid).get()

        campaignData.value = { ...campaignDoc.data(), id: campaignDoc.id }

        const cpCampaignsHits = await CampaignsService.getCampaignsByIds(campaignsIds)

        cpCampaignsInfo.value = cpCampaignsHits.data.hits.map(
            hit => ({
                ...hit._source,
                link: (
                    campaignData.value.crossprom_urls && campaignData.value.crossprom_urls[hit._source.id]
                ) || 'https://www.crossprom.com'
            })
        ).map(item => {
            if(spotsPositions && spotsPositions[item.id]){
                item.spotPosition = +spotsPositions[item.id] + 1
            }
            
            item.promo_image = getProperPromoImage(item)
            return item
        }).sort((a, b) => a.spotPosition - b.spotPosition)

        loading.value = false
        
    }


    const saveDraftOnKickstarter = () => {

        const eventInfo =  {
            campaignName: campaignData.value.title,
            updateId: updateInfo.id,
            updateDate: formattedDate.value
        }

        const kickstarterDraftUrl = updateInfo.kickstarterDraftUrl
        let draftInProcess = updateInfo.draftInProcess

        if(!campaignData.value.manageCommunityAccess){
            return store.commit('TOGGLE_MODAL', ['processing-kickstarter-draft', {
                hasNoManageCommunityAccess: true,
                projectUrl: campaignData.value.project_url.split('?')[0],
                kickstarterDraftUrl,
                eventInfo
            }]);
        }

        if(!kickstarterDraftUrl && !draftInProcess){
            // if we're in production mode, use real url, otherwise one of tcf's campaigns
            const projectUrl = process.env.NODE_ENV === 'production' ? 
                campaignData.value.project_url : 
                'https://www.kickstarter.com/projects/uniek-pottery-studio/uniek-your-portable-pottery-studio?ref=user_menu'

            postUpdates({
                updateId: updateInfo.id,
                upadateTitle: 'Update: ' + formattedDate.value,
                projectUrl,
                projectId: campaignData.value.id,
                userId: campaignData.value.author_id,
                campaigns: cpCampaignsInfo.value
            })

            draftInProcess = true
        }

        return store.commit('TOGGLE_MODAL', ['processing-kickstarter-draft', {
            kickstarterDraftUrl,
            draftInProcess,
            eventInfo,
        }]);

    }


    return {
        loading,
        cpCampaignsInfo,
        campaignData,
        formattedDate,
        canPostUpdate,
        saveDraftOnKickstarter,
        getPromoInfo,
    }
}

export default useCpInfo